// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"EmailIcon_iconContainer__odbNE","iconStyle":"EmailIcon_iconStyle__LuI43"};